<template>
  <div>
    <b-card>
      <b-card-body>
        <b-row>
          <h2>{{logictype.description}}</h2>
        </b-row>
        <b-row>
          <b-col cols=1>
            <b-input v-model="searchFor" placeholder="Sök"></b-input>
          </b-col>
          <b-col cols="1">
          </b-col>
          <b-col>
            <b-button @click="CreateNew()">
              <b-icon-plus></b-icon-plus>
              Ny</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="1">
            <b-row v-for="ls in GetLogicSets(searchFor)" :key="ls">
              <b-button block variant="outline-secondary" @click="EditLogicSet(ls)">{{ls}}</b-button>
            </b-row>
          </b-col>
          <b-col>
            <logicset v-if="editLogicSet" v-bind:name="editLogicSet" v-bind:logictype="logictype.name"></logicset>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import { Api } from "../../lib/api";
import logicset from "./logicset";
const api = new Api();

export default {
  name: "logictype",
  props: { logictype: Object },
  components: { logicset },
  data() {
    return {
      logicsets: [],
      searchFor: '',
      editLogicSet: null
    };
  },
  created() {
    if (this.logictype) this.GetData();
  },
  watch: {
    logictype: function () {
      this.GetData();
    }
  },
  methods: {
    GetData() {
      //const url = "/api/apiConfiguration/GetLogicSets";
      const url = "/api/Configuration/GetLogicSets";
      api
        .get(url+"?logictype=" + this.logictype.name)
        .then((res) => {
          this.logicsets = res.data;
          this.searchFor='';
          this.editLogicSet = null;
        });
    },
    GetLogicSets(filter) {
      if(!this.logicsets) 
        return [];
      if(!filter)
        return this.logicsets;
      var sf = filter.toUpperCase();
      return this.logicsets.filter(x => x.toUpperCase().indexOf(sf)>=0);
    },
    CreateNew() {
      var name = prompt('Namn på ny logikuppsättning');
      if(name) {
        if(this.GetLogicSets(name).length>0) {
          alert('Logikuppsättning '+name+' finns redan.');
          return;
        }        
        //alert('TODO: Edit new logicset');
        this.EditLogicSet(name);
      }      
    },
    EditLogicSet(logicsetname) {
      this.editLogicSet = logicsetname;
    }
  },
};
</script>